(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bt-cart-locale')) {
  let countryPromise;
  function detectedCountry(root) {
    if (!countryPromise) {
      countryPromise = (async () => {
        const controller = new AbortController();
        const timer = setTimeout(() => controller.abort(), 8000);
        try {
          const response = await fetch(root.replace(/\/?$/, '/') + 'browsing_context_suggestions.json?country[enabled]=true', {
            credentials: 'same-origin', signal: controller.signal
          });
          if (!response.ok) return '';
          const data = await response.json();
          return String(data?.detected_values?.country?.handle || '').toUpperCase();
        } catch (error) { return ''; }
        finally { clearTimeout(timer); }
      })();
    }
    return countryPromise;
  }
  customElements.define('bt-cart-locale', class extends HTMLElement {
    connectedCallback() {
      this.disconnectedCallback();
      this.active = false;
      const version = this.version;
      // Attend la fin du parsing du tiroir avant de chercher ses éléments.
      queueMicrotask(() => {
        if (!this.isConnected || this.version !== version) return;
        this.drawer = this.closest('#cart-drawer');
        if (!this.drawer || this.dataset.enabled !== 'true') return;
        const countries = new Set((this.dataset.countries || '').toUpperCase().split(/[\s,;]+/).filter(Boolean));
        this.observer = new MutationObserver(() => {
          if (this.active && this.isConnected) this.translate();
        });
        this.observer.observe(this.drawer, {subtree: true, childList: true, characterData: true});
        if (countries.has((this.dataset.country || '').toUpperCase())) {
          this.active = true;
          this.translate();
        } else if (countries.size) {
          detectedCountry(this.dataset.root || '/').then(country => {
            if (!this.isConnected || this.version !== version) return;
            this.active = countries.has(country);
            if (this.active) this.translate();
          });
        }
      });
    }

    translate() {
      const setText = (element, value) => {
        if (element && value && element.textContent !== value) element.textContent = value;
      };
      const setAttribute = (element, name, value) => {
        if (element && value && element.getAttribute(name) !== value) element.setAttribute(name, value);
      };
      this.drawer.querySelectorAll('[data-bt-cart-text-fr]').forEach(element => setText(element, element.dataset.btCartTextFr));
      ['aria-label','alt'].forEach(name => {
        this.drawer.querySelectorAll(`[data-bt-cart-${name}-fr]`).forEach(element => {
          setAttribute(element, name, element.getAttribute(`data-bt-cart-${name}-fr`));
        });
      });
      // Le titre natif contient aussi le compteur : on garde ses éléments intacts.
      const heading = this.drawer.querySelector('#cart-drawer-heading');
      const title = this.dataset.empty === 'true' ? this.dataset.labelEmpty : this.dataset.labelCart;
      if (heading) {
        const node = [...heading.childNodes].find(node => node.nodeType === Node.TEXT_NODE && node.textContent.trim());
        if (node && node.textContent.trim() !== title) node.textContent = title + ' ';
      }
      this.drawer.querySelectorAll('.cart-items__empty-button .button-text').forEach(el => setText(el, this.dataset.labelContinue));
      this.drawer.querySelectorAll('.theme-drawer__close-button').forEach(el => setAttribute(el, 'aria-label', this.dataset.labelClose));
      this.drawer.querySelectorAll('.quantity-selector input[type="number"]').forEach(el => setAttribute(el, 'aria-label', this.dataset.labelQuantity));
      this.drawer.querySelectorAll('.quantity-selector button[name="plus"]').forEach(el => setAttribute(el, 'aria-label', this.dataset.labelIncrease));
      this.drawer.querySelectorAll('.quantity-selector button[name="minus"]').forEach(el => setAttribute(el, 'aria-label', this.dataset.labelDecrease));
      this.drawer.querySelectorAll('[data-bt-cart-login] a, .cart-items__wrapper--drawer-empty p a').forEach(el => setText(el, this.dataset.labelLogin));
    }

    disconnectedCallback() {
      this.version = (this.version || 0) + 1;
      if (this.observer) this.observer.disconnect();
      this.observer = null;
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
